module.exports = __webpack_public_path__ + "img/ios_download_ho.f5e3e8b7.jpg";